import dayjs from "dayjs";
import {CouponStatus, CouponStatusModifyType, DialogType} from "@/config";
import {addEditDialog} from "@/pages/addnewcoupon/_couponDialog";

/**
 * 商品管理
 */
export default {
  body: {
    type: 'crud',
    actions: {
      query: {
        api: 'admin/coupon/queryCouponListPage',
      },
      detail: { dialog: addEditDialog(DialogType.VIEW) },
      revoke: {
        api: 'admin/coupon/modifyCouponStatus',
        payload: { couponCode: '${data.row.couponCode}', modifyType: CouponStatusModifyType.REVOKE },
        message: '撤回后，用户所有该类型优惠券立即失效。是否确定撤回？'
      },
      close: {
        api: 'admin/coupon/modifyCouponStatus',
        payload: { couponCode: '${data.row.couponCode}', modifyType: CouponStatusModifyType.CLOSE },
        message: '是否确定下架？'
      },
    },
    search: {
      items: [
        { type: 'input', prop: 'skuCode', label: '券名称', span: 6, placeholder: '输入券名称' },
        {
          label: '创建时间',
          type: 'date-picker',
          prop: 'gmtCreate',
          pickerType: 'datetime',
          format: 'YYYY-MM-DD HH:mm',
          afterToday: true,
        },
        { label: '券类型', type: 'select', prop: 'couponType', options: 'couponType' }
      ]
    },
    toolbar: {
      noExport: true,
      items: []
    },
    table: {
      operation: {
        width: 150,
        items: [
          { action: 'revoke', label: '撤销', visibleOn: `this.data.row.status === ${CouponStatus.NORMAL}` },
          { action: 'close', label: '下架', visibleOn: `this.data.row.status === ${CouponStatus.NORMAL}` },
          { action: 'detail' },
        ]
      },
      columns: [
        { label: '劵ID', prop: 'couponCode', minWidth: 180 },
        { label: '券名称', prop: 'couponName', minWidth: 150 },
        { label: '优惠方式', prop: 'couponTypeName', minWidth: 150 },
        // { label: '领取时间', prop: 'gmtModified', minWidth: 120,
        //   formatter: (row: any) => {
        //     const date = dayjs(row.gmtModified)
        //     return date.format('YYYY-MM-DD HH:mm:ss')
        //   }
        // },
        { label: '创建时间', prop: 'gmtCreate', minWidth: 150 ,
          formatter: (row: any) => {
            const date = dayjs(row.gmtCreate)
            return date.format('YYYY-MM-DD HH:mm:ss')
          }
        },
        { label: '券状态', prop: 'statusName', minWidth: 120 },
        { label: '领取数量', prop: 'receivedCount', minWidth: 120 },
        { label: '核销数量', prop: 'writtenOffCount', minWidth: 120 },
      ]

    }
  }
}
